/**
 * useWorkingClaimWritten
 *
 * Reactive read of the session-scoped working-billing-claim write tracker.
 * `true` once this encounter's claim has been written locally at all — whether
 * the provider edited the codes or accepted the model's suggestion.
 *
 * This is the "may I overwrite what is on screen?" predicate. For the narrower
 * "should suggestion UI stand down?" question use `useWorkingClaimEdited`.
 *
 * See `utils/workingClaimEditTracker` for why the two differ (GDN-2614 / U3).
 */

import { useCallback, useSyncExternalStore } from 'react';

import {
  hasWorkingClaimWrite,
  subscribeToWorkingClaimEdits,
} from '../utils/workingClaimEditTracker';

export function useWorkingClaimWritten(encounterId: string | null | undefined): boolean {
  const getSnapshot = useCallback(() => hasWorkingClaimWrite(encounterId), [encounterId]);
  // Server snapshot: never suppress during SSR/hydration.
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribeToWorkingClaimEdits, getSnapshot, getServerSnapshot);
}
